/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface VisualWorkflowBuilderV2HighlightControlPanelArgs {
  highlightedNodeIds: string[];
  isSaving: boolean;
  isSelectingDropAreaThroughClick: boolean;
  onMove: () => unknown;
  onCopy: () => unknown;
  onCopyTo: () => unknown;
  onDelete: () => unknown;
  canCopy: boolean;
  canCopyTo: boolean;
  canMove: boolean;
  canDelete: boolean;
  hasHighlightedExitNodes: boolean;
  isDisabledDueToRedactedUser: boolean;
  hasReadOnlyPermission: boolean;
}

export default class VisualWorkflowBuilderV2HighlighControlPanel extends Component<VisualWorkflowBuilderV2HighlightControlPanelArgs> {
  get deleteBtnDisabled() {
    return (
      this.args.hasReadOnlyPermission || this.args.isSaving || this.args.hasHighlightedExitNodes || !this.args.canDelete
    );
  }

  get deleteTooltipContent() {
    if (this.args.hasHighlightedExitNodes) {
      return 'This selection cannot be deleted until the branches containing exits are deleted or reconnected to valid paths';
    }

    if (this.args.isDisabledDueToRedactedUser) {
      return 'You do not have permission to delete the selection. Contact the account admin for more information.';
    }

    return "This selection can't be deleted because it contains exits that cannot be changed";
  }

  get copyTooltipContent() {
    if (this.args.isDisabledDueToRedactedUser) {
      return 'You do not have permission to copy the selection. Contact the account admin for more information.';
    }
    return "This selection can't be copied because it contains exits that cannot be changed";
  }
}
